module.exports = __webpack_public_path__ + "static/img/env23.ca51a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env23.png
// module id = 589
// module chunks = 4